import { forwardRef } from "react"

import { cn } from "@/lib/utils"

export type CardProps = {
  id?: string
  className?: string
  children: React.ReactNode
}

export const Card = forwardRef(function Card(
  { id, className, children, ...rest }: CardProps,
  ref: React.Ref<HTMLDivElement>,
) {
  return (
    <div
      id={id}
      ref={ref}
      className={cn("rounded-md border border-grey-300 bg-white p-5", className)}
      {...rest}
    >
      {children}
    </div>
  )
})
